<script>
import Label from "./Label.vue";

export default {
  props: {
    item_key: {
      type: String,
      required: true,
    },
    item_value: {
      type: Boolean,
      required: false,
    },
    item: {
      type: Object,
      required: true,
    },
    submitted: {
      type: Boolean,
      required: true,
    },
    validation: {
      type: Object,
      required: true,
    },
    updateValue: {
      type: Function,
      required: true,
    },
    selectedItem: {
      type: Object,
      required: false,
    },
    last_updated: {
      type: Object,
      required: false,
    },
  },
  computed: {
    display_none_check: {
      get: function () {
        return this.d_check;
      },
      set: function (newValue) {
        this.d_check = newValue;
      },
    },
    isGlobal() {
      return this.selectedItem?.additionalProp1?.global || false;
    },
  },
  components: {
    Label,
  },
  data() {
    return {
      value: this.item_value,
      d_check: this.selectedItem
        ? this.selectedItem[this.item.displayOn]
        : false,
    };
  },
  watch: {
    last_updated: {
      handler(val) {
        if (val && this.item.displayOn && val.key == this.item.displayOn) {
          this.display_none_check =
            JSON.stringify(val.value) == this.item.displayOnValue
              ? true
              : false;
        }
        if (val && this.item.displayOn2 && val.key == this.item.displayOn2) {
          if (typeof val.value != "string") {
            this.display_none_check2 =
              JSON.stringify(val.value) == this.item.displayOnValue2
                ? true
                : false;
          } else {
            this.display_none_check2 =
              val.value == this.item.displayOnValue2 ? true : false;
          }
        }
      },
      deep: true,
    },
    item_value: {
      handler(val) {
        this.value = val;
      },
      deep: true,
    },
    value(val) {
      this.updateValue(this.item_key, val);
    },
    display_none_check(val) {
      this.item.display = this.item.displayOn && !val ? false : true;
    },
    display_none_check2(val) {
      this.item.display = this.item.displayOn2 && !val ? false : true;
    },
  },
};
</script>
<template>
  <div v-if="item.portalkey">
    <portal :to="item.portalkey">
      <div
        class="mt-20"
        :class="{ 'd-none': item.displayOn && !display_none_check }"
      >
        <Label v-if="!item.hideLabel" :item="item" />
        <div class="form-check">
          <input
            class="form-check-input"
            type="checkbox"
            id="checkbox"
            v-model="value"
          />
          <p class="form-check-label ml-1 text-dark" for="checkbox">
            {{ item.placeholder }}
          </p>
        </div>
        <div v-if="submitted && validation.$error" class="invalid-feedback">
          <span v-if="!validation.required">This value is required.</span>
        </div>
      </div>
    </portal>
  </div>
  <div v-else>
    <div
      class="mb-3"
      :class="{ 'd-none': item.displayOn && !display_none_check }"
    >
      <Label v-if="!item.hideLabel" :item="item" />
      <div class="form-check">
        <input
          class="form-check-input"
          type="checkbox"
          id="checkbox"
          v-model="value"
        />
        <p class="form-check-label ml-1 mb-2 text-dark" for="checkbox">
          {{ item.placeholder }}
        </p>
      </div>
      <div v-if="submitted && validation.$error" class="invalid-feedback">
        <span v-if="!validation.required">This value is required.</span>
      </div>
    </div>
  </div>
</template>
<style scoped>
.form-check-input {
  cursor: pointer;
  width: 16px;
  height: 16px;
}
.mt-20 {
  margin-top: 20px;
}
</style>
